import { MotionConfig } from 'motion/react';

export function MotionProvider({ children }) {
  return (
    <MotionConfig reducedMotion="user" transition={{ duration: 0.2 }}>
      {children}
    </MotionConfig>
  );
}
